import { commonSettings } from './commonSettings';
export var PERFORMANCE_URL = 'https://mstr.cofit.me/MicroStrategyLibrary/auth/ui/loginPage';
export var PRO_ONE_TARGET_URL = 'https://pro-web.cofit.me/#/consulting/consulting_target';
export var PRO_ONE_URL = 'https://pro-web.cofit.me/#/login';
export var PRO_ONE_DIET_URL = 'https://pro-web.cofit.me/#/consulting/consulting_phr';
export var POS_GOOD_LIST_URL = 'https://ec-console.cofit.me/pos/goods-list';
export var IMAGE_PLACE_HOLDER_URL = 'https://placehold.co';
export var GOOGLE_STORAGE_UPLOAD_URL_PREFIX = 'https://www.googleapis.com/upload/storage/';
export var COFIT_CLIENT_SITE = commonSettings.isProductionEnv ? 'https://client.cofit.me' : 'https://client-staging.vercel.cofit.me';